<template>
  <div>
    <el-popover
        :popper-class="msgPopperClass"
        trigger="focus">
      <div class="is-error-msg">
        {{ $errorMsg }}
      </div>
      <el-input
          slot="reference"
          ref="input"
          v-validate="validationRule"
          :data-vv-name="uid"
          :data-vv-scope="validationScope"
          :class="{'is-error': $errorMsg }"
          :value="setValue"
          :name="name"
          :type="type"
          :maxlength="maxlength"
          :minlength="minlength"
          :placeholder="placeholder"
          :clearable="clearable"
          :disabled="disabled"
          :size="size"
          :prefix-icon="prefixIcon"
          :suffix-icon="suffixIcon"
          :rows="rows"
          :autosize="autosize"
          :auto-complete="autoComplete"
          :readonly="readonly"
          :resize="resize"
          :autofocus="autofocus"
          :show-password="showPassword"
          :form="form"
          :label="label"
          :tabindex="tabindex"
          @input="updateInputValue"
          @focus="onFocus"
          @blur="onBlur">
        <template slot="prepend"><slot name="prepend" /></template>
        <template slot="prefix"><slot name="prefix" /></template>
        <template slot="suffix"><slot name="suffix" /></template>
        <template slot="append"><slot name="append" /></template>
      </el-input>
    </el-popover>
    <div v-show="!popoverErrorMsg && $errorMsg"
        class="is-error-msg">
      {{ $errorMsg }}
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import ValidCore from '@/components/atoms/BaseValidCore'
const customValidationRules = (v) => {
  // xml禁止文字有無チェック
  v.$validator.extend('checkEscapeChar', {
    getMessage: (name) => `不正な文字が入力されています。`,
    validate: (inputValue, args) => {
      // [#x10000-#x10FFFF]を空文字置換
      // ※許可されているサロゲート文字ならばセットで問題ない空文字に置換。
      //   サロゲートが片方だけある場合は↑の正規表現からNGとなる
      let str = inputValue.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '')

      const reg = '[\u0009]|[\u000A]|[\u000D]|[\u0020-\uD7FF]|[\uE000-\uFFFD]'
      for (let i = 0; i < str.length; i++) {
        const chr = str.charAt(i)
        if (!RegExp(reg).test(chr)) {
          return false
        }
      }
      return true
    }
  })
}
export default {
  inject: ['parentValidator'],
  name: 'BaseValidInput',
  mixins: [ValidCore],
  props: {
    //  Input Attributes
    size: {
      type: String,
      default: undefined,
      validator: function (value) {
        return ['medium', 'small', 'mini'].indexOf(value) !== -1
      }
    },
    resize: {
      type: String,
      default: undefined,
      validator: function (value) {
        return ['none', 'both', 'horizontal', 'vertical'].indexOf(value) !== -1
      }
    },
    form: { type: String, default: undefined },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    type: { type: String, default: 'text' },
    autosize: { type: [Boolean, Object], default: false },
    autoComplete: {
      type: String,
      default: 'off',
      validator: function (value) {
        return ['on', 'off', 'new-password'].indexOf(value) !== -1
      }
    },
    suffixIcon: { type: String, default: undefined },
    prefixIcon: { type: String, default: undefined },
    label: { type: String, default: undefined },
    clearable: { type: Boolean, default: false },
    tabindex: { type: String, default: undefined },
    rows: { type: Number, default: 1 },
    placeholder: { type: String, default: undefined },
    maxlength: { type: Number, default: undefined },
    minlength: { type: Number, default: undefined },
    autofocus: { type: Boolean, default: false },
    showPassword: { type: Boolean, default: false }
  },
  data () {
    return {
      whenFocused: null
    }
  },
  computed: {
    uid () {
      return this._uid.toString()
    },
    validationRule () {
      return 'checkEscapeChar'
    },
    validationScope () {
      return _.get(this.$attrs, 'data-vv-scope', 'BaseValidInput')
    },
    setValue () {
      return this.inputValue != null ? this.inputValue.toString() : ''
    },
    $errorMsg () {
      if (this.errors.has(this.uid, this.validationScope)) {
        return this.errors.first(this.uid, this.validationScope)
      }
      return this.errorMsg
    }
  },
  created () {
    this.$validator = this.parentValidator
    customValidationRules(this)
  },
  methods: {
    onFocus (event) {
      this.whenFocused = _.cloneDeep(this.inputValue)
      this.$emit('focus', event)
    },
    onBlur (event) {
      this.$emit('blur', event, this.whenFocused, this.inputValue)
    },
    // 親からインプット要素をフォーカスするために使われる
    focus: function () {
      this.$refs.input.focus()
    }
  }
}
</script>
